import type { Transition } from 'framer-motion';

/** Canonical ease-out curve (aligned with admin filter panels). */
export const easeStandard = [0.22, 1, 0.36, 1] as const;

export type MotionEaseStandard = typeof easeStandard;

/** Framer Motion durations (seconds). */
export const durationMicro = 0.22;
export const durationSurface = 0.3;
export const durationReveal = 0.48;

/** Admin filter panels — slightly longer than surface for perceived smoothness. */
export const durationFilterResetChip = 0.32;
export const durationFilterMobilePanel = 0.42;

export type MotionVariant = 'micro' | 'surface' | 'reveal';

function durationForVariant(variant: MotionVariant): number {
    switch (variant) {
        case 'micro':
            return durationMicro;
        case 'reveal':
            return durationReveal;
        default:
            return durationSurface;
    }
}

export function framerTransition(variant: MotionVariant = 'surface'): Transition {
    return {
        duration: durationForVariant(variant),
        ease: easeStandard as [number, number, number, number],
    };
}
